export default "__VITE_ASSET__DPHP2O4j__"